(function () {
  'use strict';

  var FRAME_ID = 'BIS_frame';
  var STYLE_ID = 'superbreakers-bis-theme';
  var FONT_LINK_ID = 'superbreakers-bis-font';
  var LABEL_CLASS = 'superbreakers-bis-label';

  var modalStyles = `
    :root {
      color-scheme: light;
      --sb-teal: #11566b;
      --sb-teal-dark: #0c3d4c;
      --sb-border: #cbd8dd;
      --sb-muted: #66777e;
      --sb-surface: #ffffff;
      --sb-radius: 6px;
    }

    *, *::before, *::after { box-sizing: border-box; }

    html,
    body {
      font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    }

    body.fadein {
      align-items: center !important;
      background: rgba(19, 47, 63, 0.68) !important;
      display: flex !important;
      justify-content: center !important;
      overflow: auto !important;
      padding: 24px !important;
    }

    #BISModal,
    #BISModal .modal,
    #BISModal .modal-dialog {
      width: 100% !important;
    }

    #BISModal .modal-dialog {
      margin: 0 auto !important;
      max-width: 440px !important;
    }

    #container.modal-content {
      background: var(--sb-surface) !important;
      border: 0 !important;
      border-radius: 10px !important;
      box-shadow: 0 18px 52px rgba(12, 61, 76, 0.2) !important;
      max-height: calc(100dvh - 48px) !important;
      overflow: auto !important;
      position: relative !important;
    }

    #BISModal .modal-header {
      align-items: center !important;
      border-bottom: 0 !important;
      display: flex !important;
      min-height: 56px !important;
      padding: 16px 20px 10px !important;
    }

    #bis-modal-title {
      color: var(--sb-teal-dark) !important;
      font-size: 20px !important;
      font-weight: 600 !important;
      letter-spacing: 0 !important;
      line-height: 1.3 !important;
      margin: 0 !important;
      padding-right: 16px !important;
      text-transform: none !important;
    }

    #BISModal .close {
      align-items: center !important;
      border-radius: 50% !important;
      color: var(--sb-teal-dark) !important;
      cursor: pointer !important;
      display: flex !important;
      flex: 0 0 36px !important;
      font-family: Arial, sans-serif !important;
      font-size: 20px !important;
      height: 36px !important;
      justify-content: center !important;
      line-height: 1 !important;
      margin: -6px -8px -6px auto !important;
      transition: background-color 150ms ease, color 150ms ease !important;
    }

    #BISModal .close:hover,
    #BISModal .close:focus-visible {
      background: #e8f1f4 !important;
      color: var(--sb-teal) !important;
      outline: 2px solid transparent !important;
    }

    #BISModal .modal-body {
      color: #27383e !important;
      padding: 0 20px 18px !important;
    }

    #bis-modal-desc {
      border: 0 !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      height: 1px !important;
      margin: -1px !important;
      overflow: hidden !important;
      padding: 0 !important;
      position: absolute !important;
      white-space: nowrap !important;
      width: 1px !important;
    }

    #BISModal .product-name {
      color: #475a61 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1.4 !important;
      margin: 0 0 14px !important;
    }

    #BISModal .form-group {
      margin: 0 0 12px !important;
    }

    #BISModal .single_variant_product_select {
      display: none !important;
    }

    .superbreakers-bis-label {
      color: var(--sb-teal-dark) !important;
      display: block !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      line-height: 1.4 !important;
      margin: 0 0 7px !important;
    }

    #BISModal .form-control {
      background: #fff !important;
      border: 1px solid var(--sb-border) !important;
      border-radius: var(--sb-radius) !important;
      box-shadow: none !important;
      color: #27383e !important;
      font-family: inherit !important;
      font-size: 15px !important;
      font-weight: 400 !important;
      height: 44px !important;
      line-height: 1.4 !important;
      padding: 10px 12px !important;
      transition: border-color 150ms ease, box-shadow 150ms ease !important;
      width: 100% !important;
    }

    #BISModal select.form-control {
      appearance: auto !important;
    }

    #BISModal .form-control::placeholder {
      color: #75858b !important;
      opacity: 1 !important;
    }

    #BISModal .form-control:hover {
      border-color: #91aab3 !important;
    }

    #BISModal .form-control:focus {
      border-color: var(--sb-teal) !important;
      box-shadow: 0 0 0 3px rgba(17, 86, 107, 0.14) !important;
      outline: 0 !important;
    }

    #submit-btn {
      align-items: center !important;
      background: var(--sb-teal) !important;
      border: 1px solid var(--sb-teal) !important;
      border-radius: var(--sb-radius) !important;
      box-shadow: none !important;
      color: #fff !important;
      cursor: pointer !important;
      display: flex !important;
      font-family: inherit !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      justify-content: center !important;
      line-height: 1.35 !important;
      min-height: 44px !important;
      padding: 10px 16px !important;
      transition: background-color 150ms ease, border-color 150ms ease, transform 150ms ease !important;
      width: 100% !important;
    }

    #submit-btn:hover {
      background: var(--sb-teal-dark) !important;
      border-color: var(--sb-teal-dark) !important;
    }

    #submit-btn:active { transform: translateY(1px) !important; }

    #submit-btn:focus-visible {
      box-shadow: 0 0 0 3px #fff, 0 0 0 5px var(--sb-teal) !important;
      outline: 0 !important;
    }

    #BISModal .small-print {
      color: var(--sb-muted) !important;
      font-size: 12px !important;
      line-height: 1.4 !important;
      margin: 4px 0 0 !important;
    }

    #BISModal .alert {
      border: 0 !important;
      border-radius: var(--sb-radius) !important;
      font-family: inherit !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      padding: 14px 16px !important;
    }

    @media (max-width: 575px) {
      body.fadein { padding: 10px !important; }

      #container.modal-content {
        border-radius: 8px !important;
        max-height: calc(100dvh - 20px) !important;
      }

      #BISModal .modal-header {
        min-height: 52px !important;
        padding: 14px 16px 8px !important;
      }

      #bis-modal-title { font-size: 18px !important; }

      #BISModal .modal-body { padding: 0 16px 16px !important; }

      #BISModal .product-name {
        font-size: 14px !important;
        margin-bottom: 12px !important;
      }

      #BISModal .form-control { font-size: 16px !important; }
    }

    @media (prefers-reduced-motion: reduce) {
      #BISModal .close,
      #BISModal .form-control,
      #submit-btn { transition: none !important; }
    }
  `;

  function addLabel(doc, control, text) {
    if (!control || !control.parentElement || control.parentElement.querySelector('.' + LABEL_CLASS)) return;

    if (!control.id) control.id = 'superbreakers-bis-' + text.toLowerCase().replace(/[^a-z0-9]+/g, '-');

    var label = doc.createElement('label');
    label.className = LABEL_CLASS;
    label.htmlFor = control.id;
    label.textContent = text;
    control.parentElement.insertBefore(label, control);
  }

  function enableBackdropClose(doc) {
    if (!doc.documentElement || doc.documentElement.dataset.superbreakersBackdropClose === 'true') return;

    doc.documentElement.dataset.superbreakersBackdropClose = 'true';
    doc.addEventListener('click', function (event) {
      var content = doc.querySelector('#container.modal-content');
      if (!content || content.contains(event.target)) return;

      var close = doc.querySelector('#BISModal .close');
      if (close) close.click();
    }, true);
  }

  function themeFrame(frame) {
    var doc;

    try {
      doc = frame.contentDocument || frame.contentWindow.document;
    } catch (error) {
      return;
    }

    if (!doc || !doc.head || !doc.body || !doc.querySelector('#BISModal')) return;

    if (!doc.getElementById(FONT_LINK_ID)) {
      var storefrontFont = document.querySelector('link[href*="fonts.googleapis.com"][href*="Poppins"]');
      if (storefrontFont) {
        var fontLink = storefrontFont.cloneNode();
        fontLink.id = FONT_LINK_ID;
        doc.head.appendChild(fontLink);
      }
    }

    if (!doc.getElementById(STYLE_ID)) {
      var style = doc.createElement('style');
      style.id = STYLE_ID;
      style.textContent = modalStyles;
      doc.head.appendChild(style);
    }

    var title = doc.getElementById('bis-modal-title');
    if (title && title.textContent.trim() === 'NOTIFY ME WHEN AVAILABLE') {
      title.textContent = 'Notify me';
    } else if (title && title.textContent.trim() === 'Notify me when available') {
      title.textContent = 'Notify me';
    }

    var submit = doc.getElementById('submit-btn');
    if (submit && submit.textContent.trim() === 'Notify me when available') submit.textContent = 'Notify me';

    addLabel(doc, doc.getElementById('variants'), 'Condition');
    addLabel(doc, doc.querySelector('#email-address input[type="email"]'), 'Email address');
    enableBackdropClose(doc);
  }

  function connectFrame(frame) {
    if (!frame || frame.dataset.superbreakersThemeConnected === 'true') return;

    frame.dataset.superbreakersThemeConnected = 'true';
    frame.addEventListener('load', function () { themeFrame(frame); });
    themeFrame(frame);

    var attempts = 0;
    var readinessTimer = window.setInterval(function () {
      attempts += 1;
      themeFrame(frame);
      if (attempts >= 40) window.clearInterval(readinessTimer);
    }, 250);
  }

  function findFrame() {
    connectFrame(document.getElementById(FRAME_ID));
  }

  findFrame();

  var observer = new MutationObserver(findFrame);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
